import { render, staticRenderFns } from "./original.vue?vue&type=template&id=20fbbf90&scoped=true"
import script from "./original.vue?vue&type=script&lang=js"
export * from "./original.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbbf90",
  null
  
)

export default component.exports